import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../elements/Navbar';
import Form from '../components/Form';
import InputField from '../components/InputField';
import ResponseBlock from '../components/ResponseBlock';
import { BeatLoader } from 'react-spinners';

function FlavorUpdater() {
  const [userEmail, setUserEmail] = useState('');
  const [file, setFile] = useState(null);
  const [isFileEmpty, setIsFileEmpty] = useState(false);
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
      const email = localStorage.getItem("userEmail"); // ✅ Retrieve email from localStorage
      if (email) {
        setUserEmail(email);
      }
    }, []);
  
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setMessage('');
    setErrors(false);
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setFile(null);
    setIsFileEmpty(false);
    setMessage('');
  };

  const handleSubmit = async (event) => {
    setIsFileEmpty(false);
    
    if (!file) {
      setIsFileEmpty(true);
      setErrors(true);
      setMessage('Please select a file before submitting.');
      return;
    };

    setIsLoading(true);
    setMessage('');
    
    const formData = new FormData();
    formData.append('file', file);

    formData.append('email', userEmail);

    try {
      const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_BASE_DEV : process.env.REACT_APP_API_URL_BASE_PROD;
      const response = await axios.post(`${baseUrl}/csv_processor/update-product-flavors`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const data = response.data;

      if (data.error) {
        setIsLoading(false);
        setErrors(true);
        setMessage(data.error);
      } else {
        setIsLoading(false);
        setMessage(data.message);
      }

    } catch (error) {
      console.error("There was an error uploading the file!", error);
      setMessage('An error occurred while uploading the file.');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1450)
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container mx-auto">
        <div className="updaterWrapper">
          <div className="space-y-12">
            <h1 className="text-2xl font-semibold leading-7 text-gray-900">Flavor Updater App</h1>
            <p>
              The Flavor Updater App allows you to update the flavors of your products in bulk using a CSV file. This app is designed to work with Shopify's Matrixify app, which is used to import and export data in CSV format.
              <br />
              <br />
              <span className="text-sm text-gray-500 font-bold">Note: There is currently a webhook implemented that is triggered when a new Product is created in Shopify. This webhook will automatically update the flavors of the new product automatically based on the Flavors Definitions that were defined. This webhook is only triggered when a new Product is created, not when a Product is updated.</span>
            </p>
            <div className="border-b border-gray-900/10 pb-12">
              <h2 className="text-base font-semibold leading-7 text-gray-900">Upload CSV from Matrixify</h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                The Product Metafield Updater App expects a CSV file with the appropriate columns. If you are unaware of what columns are needed check out the Tutorial page for more information.
              </p>
            </div>
          </div>
          <div className="formWrapper mt-11">
            <Form onSubmit={handleSubmit}>
              <div className="grid grid-cols-6 border-b border-gray-900/10 pb-12 space-y-2">
                <div className="col-start-3 col-span-2 relative">
                  <InputField 
                    label="Choose a file" 
                    type="file" 
                    name="csv_file" 
                    onChange={handleFileChange}
                    error={isFileEmpty}
                    classes="w-full text-sm text-slate-500 p-3 outline-0
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-violet-50 file:text-violet-700
                            hover:file:bg-violet-100 mb-4"
                  />
                </div>
                <div className="col-end-5 col-span-1 text-right space-x-3">
                  <button className="text-rose-700 font-semibold py-2 px-4 rounded" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button className="w-1/2 bg-indigo-500 text-white font-bold py-2 px-4 rounded-lg" 
                          type="submit"
                          disabled={isLoading}>
                    { isLoading ? <BeatLoader /> : 'Submit' }
                  </button>
                </div>
              </div>
            </Form>
          </div>
          <div className="responseWrapper">
            <ResponseBlock 
              message={message}
              errors={errors}
              fileType='csv'
            />
          </div>
          </div>
        </div>
    </div>
  )
}

export default FlavorUpdater;